// extracted by mini-css-extract-plugin
module.exports = {"image":"ProfileImage-module__image___1yHQ4"};